<template>
  <div class="sku-platform">
    <span v-show="platform.name == 'jd'" class="jd-icon">
      <img src="../assets/img/source.png" alt="">
    </span>
    <span class="normal" v-show="platform.name != 'jd'">{{platform.brand}}</span>
  </div>
</template>

<script>
export default {
  name: 'skuPlatform',
  props: {
    platform: {
      type: Object,
      required: true
    }
  },
  computed: {
    // platformName () {
    //   switch (this.platform) {
    //     case 'jd':
    //       return '京东商城'
    //     case 'yanxuan':
    //       return '网易严选'
    //     case 'sfbest':
    //       return '顺丰优选'
    //     case 'elianmeng':
    //       return 'E联盟'
    //     case 'bjwanyue':
    //       return '厂家直供'
    //     default:
    //       return ''
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
.sku-platform {
  .flex-center;
  font-size: @fz18;
  color: #fff;
  display: inline-flex;
  margin-right: 0.1rem;
  span {
    display: inline-block;
    height: 0.34rem;
    background: linear-gradient(#FF4E4E, #F53333);
  }
  .normal {
    padding: 0 0.1rem;
    .flex-center;
  }
  .jd-icon {
    padding: 0;
    background: none;
    width: 0.88rem;
    padding-top: 0.08rem;
    img {
      width: 0.88rem;
      height: 0.34rem;
      margin-top: -0.08rem;
      // vertical-align: middle;

    }
  }

}
</style>
